import React, { useState, useEffect } from "react";
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Grid from '@mui/material/Grid';
import GPAP_Button from "../../../../gpap-lib/Button_Collection";
import OwnerSelector from "../components/OwnerSelector";
import { Redirect } from "react-router-dom";
import auth from '../../../service/Auth';
import AuthErrorDialog from "../components/AuthError";

const SelectGroup =()=>{

    const [owner, setOwner] = useState("----");
    const [next, setNext] = useState(false);
    const [back, setBack] = useState(false);
    const [valid, setValid] = useState(false);
    const [authError, setAuthError] = useState("");

    useEffect(() => {   
        if (auth.tokenExpired()){  
            setAuthError("Logging session timeout. Please log again");
        }
    });

    const goBack = (event) => {
        setBack(true);
    };

    const goNext = (event) => {
        if (valid) setNext(true);
    };    

    /* OpenID session token error*/
    if (authError !== "" ) {
        return (
            <AuthErrorDialog errors={authError} open={true}/>
        );
    }
    
    /*Go to Experiment Submission Choices*/
    if (next) {
        return <Redirect to={{pathname:'/experimentsubmissionchoices',owner:owner}}/>;
    }

    /*Go back*/
    if (back) {
        return  <Redirect to={{pathname:'/submission'}}/>;
    }

    return (
        <div className={"mainContent"}>
            <Typography variant={"h5"} align={"center"}> Submit Experiments </Typography>
            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
            >
                <Card sx={{ m:2, minWidth: 275 }}>
                    <CardContent>
                        <Typography variant="h5" component="div" align={"center"}>
                            Assign a group owner to your experiments:
                        </Typography>
                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <OwnerSelector owner={owner} setValid={setValid} setOwner={setOwner}/>
                        </Grid>       
                    </CardContent>
                    <CardActions>
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <GPAP_Button onClick={goBack}> 
                                <i class="fa fa-arrow-circle-left" aria-hidden="true"></i> 
                                BACK 
                            </GPAP_Button>
                            <GPAP_Button onClick={goNext}> NEXT 
                                <i class="fa fa-arrow-circle-right" aria-hidden="true"></i> 
                            </GPAP_Button>
                        </Grid>
                    </CardActions>
                </Card>
            </Grid> 
        </div>
    )
}

export default SelectGroup;
